exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.txContainer[data-v-19513010] {\n    height: 400px;\n    width: 100%;\n}\n\n", ""]);
